var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: {
        display: "flex",
        "align-items": "center",
        "justify-content": "end"
      }
    },
    [
      _c(
        "span",
        { staticStyle: { width: "70px" } },
        [_c("RenderMoneyColumnValue", { attrs: { value: _vm.invoiceValue } })],
        1
      ),
      _vm._v(" "),
      _c("span", { staticStyle: { padding: "0 5px" } }, [_vm._v("|")]),
      _vm._v(" "),
      _c(
        "span",
        { staticStyle: { width: "20px" } },
        [
          _c("RenderPanoramaInvoiceStatus", {
            attrs: { "panorama-invoice-status": _vm.panoramaInvoiceStatus }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }